import React from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/AdminLayout";

interface AdminCard {
  key: string;
  title: string;
  description: string;
  path: string;
}

const adminCards: AdminCard[] = [
  {
    key: "users",
    title: "Usuários",
    description: "Crie, edite e gerencie permissões dos usuários.",
    path: "/admin/usuarios",
  },
  {
    key: "campaigns",
    title: "Campanhas",
    description: "Cadastre campanhas e vincule clientes a cada uma delas.",
    path: "/admin/campanhas",
  },
  {
    key: "contexts",
    title: "Contextos",
    description: "Mantenha perguntas, respostas e versões do chatbot.",
    path: "/admin/contextos",
  },
  {
    key: "chats",
    title: "Chats",
    description: "Acompanhe sessões e revise interações recentes.",
    path: "/admin/chats",
  },
  {
    key: "notifications",
    title: "Controle de Notificações",
    description: "Ative ou desative insights que aparecem para todos os usuários.",
    path: "/admin/notificacoes",
  },
];

const AdminPanel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <style>{`
        .admin-panel-card::before {
          content: "";
          position: absolute;
          inset: -1px;
          border-radius: 14px;
          padding: 1px;
          background: linear-gradient(120deg, rgba(120, 170, 230, 0.2), rgba(140, 190, 240, 0.18), rgba(190, 210, 255, 0.16));
          -webkit-mask: linear-gradient(#000, #000) content-box, linear-gradient(#000, #000);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          opacity: 0.45;
          pointer-events: none;
        }
      `}</style>

      <div className="max-w-[1100px] mt-[80px] mb-[16px] mx-auto flex flex-col items-center gap-[8px] text-center text-[#0a1635]">
        <p className="uppercase tracking-[0.1em] text-[12px] m-0 text-[#0b1f44] font-bold">
          Central de Administração
        </p>
        <h1 className="my-[6px] text-3xl font-bold text-[#0a1635]">Painel do Admin</h1>
        <p className="m-0 text-[#0a1635]">Escolha uma área do painel para gerenciar.</p>
      </div>

      <div
        className="max-w-[1100px] mx-auto grid gap-y-[24px] gap-x-[24px] mt-[32px]"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))" }}
      >
        {adminCards.map((card) => (
          <button
            key={card.key}
            className="admin-panel-card relative overflow-hidden text-left flex flex-col gap-[10px] rounded-[14px] p-[18px] cursor-pointer text-[#0a1635] transition-all duration-150 ease-in-out group hover:-translate-y-[2px]"
            style={{
              background: "linear-gradient(125deg, rgba(255, 255, 255, 0.96), rgba(245, 249, 255, 0.92) 55%, rgba(232, 240, 252, 0.9))",
              border: "1px solid rgba(20, 80, 150, 0.16)",
              boxShadow: "0 0 0 1px rgba(10, 33, 115, 0.16), 0 0 16px rgba(10, 33, 115, 0.14), 0 10px 24px rgba(5, 24, 64, 0.12)",
              minHeight: "110px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 0 0 1px rgba(10, 33, 115, 0.35), 0 0 18px rgba(7, 28, 95, 0.2), 0 12px 28px rgba(2, 16, 54, 0.22)";
              e.currentTarget.style.background = "linear-gradient(125deg, rgba(255, 255, 255, 1), rgba(248, 250, 255, 0.95) 55%, rgba(238, 244, 255, 0.95))";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "0 0 0 1px rgba(10, 33, 115, 0.16), 0 0 16px rgba(10, 33, 115, 0.14), 0 10px 24px rgba(5, 24, 64, 0.12)";
              e.currentTarget.style.background = "linear-gradient(125deg, rgba(255, 255, 255, 0.96), rgba(245, 249, 255, 0.92) 55%, rgba(232, 240, 252, 0.9))";
            }}
            onClick={() => navigate(card.path)}
          >
            <div className="flex items-center justify-between gap-[10px] w-full">
              <h3 className="m-0 text-xl font-bold text-[#0a1635]">{card.title}</h3>
              <span className="font-bold text-[#28508c]">→</span>
            </div>
            <p className="m-0 text-[#20385c] leading-[1.4] text-sm">{card.description}</p>
          </button>
        ))}
      </div>
    </AdminLayout>
  );
};

export default AdminPanel;
